import { Paper, styled } from "@mui/material";

export const CMPaper = styled(Paper)({
    margin: "0px 20px 0px 20px",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    border: "4px 4px 4px 4px",
})